export enum ToggleNames {
  ClinicLocatorIncludeInactiveSites = 'clinicLocatorIncludeInactiveSites',
  ReviewPortalMyGrants = 'reviewPortalMyGrants',
  TableArchiveMyGrants = 'tableArchiveMyGrants',
  UsersIncludeInactives = 'usersIncludeInactives',
}
